import { log, state } from ":mods";
import { getMaterialType } from "../../methods";
import { ASubmoduleMaterial, ShowSubModuleViewProps } from "../../models";
import { createEffect, onMount, untrack } from "solid-js";
import { useSearchParams } from "@solidjs/router";

function getFilter(filter: ShowSubModuleViewProps["materialsFilter"]): ShowSubModuleViewProps["materialsFilter"] {
  if (filter === undefined || filter === null) return "all";
  if (filter !== "all" && filter !== "lesson" && filter !== "task" && filter !== "question") {
    return "all";
  }
  return filter;
}
export function MaterialFilter(props: {
  data: ASubmoduleMaterial[];
  onFiltered: (props: { arr: ASubmoduleMaterial[]; filter: ShowSubModuleViewProps["materialsFilter"] }) => void;
}) {
  const [search_params, set_search_params] = useSearchParams();
  const $filter = state.create(getFilter(search_params.filter as any));
  const all = props.data ?? [];
  const lessons = props.data?.filter((material) => getMaterialType(material) === "lesson") ?? [];
  const tasks = props.data?.filter((material) => getMaterialType(material) === "task") ?? [];
  const questions = props.data?.filter((material) => getMaterialType(material) === "question") ?? [];
  const classes = {
    active: "bg!nav-side-bga text!nav-side-texta",
    disabled: "!cursor-not-allowed !opacity-65",
  };
  createEffect((init) => {
    const filter = $filter.value;
    // console.log("mounted material filters :: ", filter);
    untrack(() => {
      const active_arr = filter === "all" ? all : filter === "lesson" ? lessons : filter === "task" ? tasks : questions;
      if (init) {
        props.onFiltered?.({ arr: active_arr, filter });
      } else if (filter !== search_params.filter) {
        props.onFiltered?.({ arr: active_arr, filter });
        set_search_params({ filter: $filter.value });
      }
    });
    return false;
  }, true);

  function onFilter(filter: ShowSubModuleViewProps["materialsFilter"]) {
    const current_filter = $filter.unwrap;
    if (filter === current_filter) {
      return;
    }
    if (filter === "all" && all.length <= 0) return;
    else if (filter === "lesson" && lessons.length <= 0) return;
    else if (filter === "task" && tasks.length <= 0) return;
    else if (filter === "question" && questions.length <= 0) return;
    $filter.set(filter);
  }
  let style =
    "space-x-2 children:(capitalize bg#pt text#p text-0.68rem cursor-pointer w-fit h-fit whitespace-nowrap px-2 py-1 rounded-5px)";
  return (
    <div class="flex flex-col h-fit mt-3 mb-4 flex-wrap space-y-2">
      <div class={`flex flex-row ${style}`}>
        <span
          class={`
        ${$filter.value === "all" ? classes.active : ""}
        ${all.length <= 0 ? classes.disabled : ""}
        `}
          onclick={() => onFilter("all")}
        >
          all {`(${all.length})`}
        </span>
        <span
          class={`
        ${$filter.value === "lesson" ? classes.active : ""}
        ${lessons.length <= 0 ? classes.disabled : ""}
        `}
          onclick={() => onFilter("lesson")}
        >
          sections {`(${lessons.length})`}
        </span>
      </div>
      <div class={`flex flex-row ${style}`}>
        <span
          class={`
        ${$filter.value === "task" ? classes.active : ""}
        ${tasks.length <= 0 ? classes.disabled : ""}
        `}
          onclick={() => onFilter("task")}
        >
          task {`(${tasks.length})`}
        </span>
        <span
          class={`
        ${$filter.value === "question" ? classes.active : ""}
        ${questions.length <= 0 ? classes.disabled : ""}
        `}
          onclick={() => onFilter("question")}
        >
          questions {`(${questions.length})`}
        </span>
      </div>
    </div>
  );
}
